import { render, staticRenderFns } from "./SvgFrontFrameResidenceCard.vue?vue&type=template&id=3c34566d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports